import React from "react";
import { useConfirmationDialog } from "hooks/useConfirmationDialog";
import ExportOrdersForm from "components/ExportOrdersForm/ExportOrdersForm";
import { Button, Paper } from "@material-ui/core";
import { GetApp as GetAppIcon } from "components/MaterialSymbol/MaterialIcons";

/**
 * Component that shows the export button and handles opening the export modal.
 */
export default function ExportOrdersModal() {
    const { openDialog, closeDialog } = useConfirmationDialog();

    const handleOpen = () => {
        openDialog({
            customDialog: true,
            fullWidth: true,
            showClose: true,
            maxWidth: "xs",
            title: "Export Orders Report",
            message: (
                <Paper style={{ padding: 20 }}>
                    <ExportOrdersForm closeDialog={closeDialog} />
                </Paper>
            ),
        });
    };

    return (
        <Button
            variant="contained"
            color="primary"
            startIcon={<GetAppIcon />}
            onClick={handleOpen}
            size="small"
        >
            Export CSV
        </Button>
    );
}
